<div class="catalog-content">
    <form
        name="form"
        (ngSubmit)="f.form.valid && processData()"
        #f="ngForm"
        novalidate
    >
        <!-- Section -->
        <div class="form-group">
            <mat-form-field>
                <mat-select
                    disableOptionCentering
                    placeholder="Section"
                    [(ngModel)]="category"
                    name="reason"
                    #reason="ngModel"
                    (selectionChange)="onSelectionChange($event)"
                    required
                >
                    <mat-option
                        *ngFor="let category of categoryList"
                        [value]="category"
                    >
                        {{ category }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="f.submitted && reason.invalid">Section is required</mat-error>
            </mat-form-field>
        </div>
        <!-- Upload File -->
        <div class="form-group">
            <app-file-input
                (fileChange)="onFileChange($event)"
                [(ngModel)]="fileName"
                name="fileName"
                placeholder="Upload Excel File"
                required="true"
            >
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                >
                    Choose
                </button>
            </app-file-input>
        </div>
        <!-- BUTTON -->
        <div class="margin-top-20 text-center">
            <button
                mat-raised-button
                color="primary"
                class="mat-button-large"
                type="submit"
                [disabled]="!f.valid"
            >
                Submit
            </button>
        </div>
    </form>
    <app-catalogue-excel-list [data]="excelList"></app-catalogue-excel-list>
</div>
